module.exports = __webpack_public_path__ + "img/2.7ce98690.png";